import React, { useContext, useRef } from 'react';
import { ResourceAlias as ResourceAliasCore, ResourceAliasProps as ResourceAliasCoreProps } from 'ia-react-core';
import { AxiosResponse } from 'axios';
import ResourcesContext from '../ResourcesContext';
import { ResourceContextInfo } from '../ResourcesContext/ResourcesContext';

export interface ResourceAliasProps<Data, Error> extends ResourceAliasCoreProps<Data, Error> {
  essential?: boolean;
}

const ResourceAlias = <Data, Error = { response: AxiosResponse }>(
  {
    resourceSrc, essential, onComplete, onSuccess, onFailure, ...props
  }: ResourceAliasProps<Data, Error>,
) => {
  const ctx = useContext(ResourcesContext);
  const resource = useRef({
    name: resourceSrc,
    essential,
    alias: true,
  } as ResourceContextInfo);
  ctx?.registerResource(resource.current);
  return (
    <ResourceAliasCore<Data, Error>
      resourceSrc={resourceSrc}
      onComplete={() => {
        ctx?.onResourceComplete(resource.current);
        if (onComplete) {
          onComplete();
        }
      }}
      onFailure={(x) => {
        const response = (x as { response: AxiosResponse })?.response;
        ctx?.onResourceFailure(resource.current, response?.status);
        if (onFailure) {
          onFailure(x);
        }
      }}
      onSuccess={(x) => {
        const response = x as AxiosResponse;
        ctx?.onResourceSuccess(resource.current, response?.status);
        if (onSuccess) {
          onSuccess(x);
        }
      }}
      {...props}
    />
  );
};

export default ResourceAlias;
